import React, { Component } from 'react'
import { pick } from 'lodash'
import ProjectApi from '../../../api/Corporates/Projects'
import Project from '../../../components/Project/Projects/Project'
import { message } from 'antd'
import { withRouter } from 'react-router-dom'

class ProjectCont extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fetching: false,
      visible: false,
      submitting: false,
      removing: false,
      type: 'new',
      current: 0,
      projectDetail: null,
      groupDetail: null,
      groupMemberDetail: null,
      templatesLists: {},
      program: {},
    }
  }

  api = new ProjectApi()
  projectRef = React.createRef()
  groupRef = React.createRef()
  groupMemberRef = React.createRef()

  async componentDidMount() {
    await this.fetch()
  }

  fetch = async () => {
    this.setState({ fetching: true })
    const key = this.props.match.params.key
    const list = await this.api.listByParent(key)
    const program = await this.api.get(key)
    const groups = await this.api.listGroupsWithMembers()
    const templatesLists = await this.api.listTemplates()
    const tags = templatesLists.group.tags
    this.setState({
      list,
      groups,
      templatesLists,
      tags,
      program,
      projectDetail: null,
      groupDetail: null,
      groupMemberDetail: null,
      fetching: false,
    })
  }
  onShow = () => {
    this.setState({ visible: true })
  }
  onCancel = () => {
    this.fetch()
    this.setState({ visible: false })
  }
  submit = async () => {
    try {
      this.setState({ submitting: true })
      const { projectDetail, groupDetail, groupMemberDetail } = this.state
      let programForm = projectDetail
      programForm.project = {
        ...programForm.project,
        ...groupDetail,
        ...groupMemberDetail,
      }
      programForm.type = 'project'
      programForm.parent = `projects/${this.props.match.params.key}`
      const program = await this.api.create(programForm)
      this.onCancel()
      this.fetch()
      this.setState({ submitting: false })
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
      this.setState({ submitting: false })
    }
  }
  remove = () => {
    this.setState({ submitting: true })
    this.setState({ submitting: false })
  }
  update = () => {
    this.setState({ submitting: true })
    this.setState({ submitting: false })
  }
  onChangeCat = (value) => {
    switch (value) {
      case 'internal':
        this.setState({ internal: true })
        this.setState({ sales: false })
        break
      case 'sales':
        this.setState({ internal: false })
        this.setState({ sales: true })
        break
      default:
        this.setState({ sales: false })
        this.setState({ internal: false })
    }
  }
  onChangeTemplate = (value) => {
    const templatesLists = this.state.templatesLists.group.template
    let template = templatesLists.find((t) => {
      return t.key === value
    })
    this.setState({ template })
  }
  onChangeGroup = (value) => {
    this.setState({ group: value })
  }
  next = async ({ isLast = false }) => {
    // same index as in SupplierRegistrationForm steps deceleration
    try {
      if (this.state.current === 0) {
        const projectDetail = await this.checkForm(this.projectRef)
        this.setState({ projectDetail })
      }
      if (this.state.current === 1 && isLast) {
        const groupDetail = await this.checkForm(this.groupRef)
        this.setState({ groupDetail })
        this.submit()
      }
      if (this.state.current === 2) {
        const groupMemberDetail = await this.checkForm(this.groupMemberRef)
        this.setState({ groupMemberDetail })
        this.submit()
      }
    } catch (e) {
      console.error(e)
    }

    const current = this.state.current + 1
    this.setState({ current, lastActionIsNext: true })
  }
  prev = () => {
    if (this.state.current === 0) {
      this.setState({ projectDetail: null })
    }

    const current = this.state.current - 1
    this.setState({ current, lastActionIsNext: false })
  }
  checkForm = (currentRef) => {
    return new Promise((res, rej) => {
      currentRef.current.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          res(values)
        }
      })
    })
  }

  render() {
    return (
      <Project
        {...this.props}
        {...this.state}
        {...pick(this, [
          'fetch',
          'onShow',
          'onCancel',
          'projectRef',
          'groupRef',
          'groupMemberRef',
          'submit',
          'remove',
          'update',
          'onChangeCat',
          'onChangeTemplate',
          'onChangeGroup',
          'next',
          'prev',
          'handleUpload',
          'beforeUpload',
          'onRemoveUpload',
        ])}
      />
    )
  }
}

export default withRouter(ProjectCont)
